<template>
  <v-text-field
    :ref="inputID"
    prepend-inner-icon="search"
    :label="$t('search')"
    class="box-search-box ml-0"
    v-model="search"
    @input="handleInput"
    hide-details
    solo
  />
</template>

<script>
import { uuid } from 'vue-uuid'
export default {
  name: 'WrldSelectableFiltersInput',
  data () {
    return {
      search: '',
      previousValue: '',
      inputID: uuid.v1()
    }
  },
  methods: {
    handleInput () {
      if (this.search != null) {
        if (this.search.length < 1 && this.previousValue !== this.search && this.previousValue.length > 0) {
          this.$emit('empty-input')
          this.previousValue = ''
        } else if (this.search.length > 0) {
          this.previousValue = this.search
          this.$emit('input', this.search)
        }
      } else {
        this.$emit('empty-input')
        this.previousValue = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
